import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ApplicationHistory } from '@shared/models';

import { applicationHistoryGet, applicationHistoryGetSuccess } from './application-history.actions';

export interface ApplicationHistoryState {
  [associationId: string]: EntityState<ApplicationHistory>;
}

export const applicationHistoryAdapter: EntityAdapter<
  ApplicationHistory
> = createEntityAdapter<ApplicationHistory>({});

export const initialState: ApplicationHistoryState = {
};

const reducer = createReducer(
  initialState,
  on(applicationHistoryGet, (state, { associationId }) => ({
    ...state,
    [associationId]: {
      ready: false,
      ...applicationHistoryAdapter.getInitialState({ ready: false, ...state[associationId] })
    },
  })),
  on(applicationHistoryGetSuccess, (state, { associationId, history }) => ({
    ...state,
    [associationId]: applicationHistoryAdapter.upsertMany(history, { ...state[associationId], ready: true }),
  })),
);

export function applicationHistoryReducer(state: ApplicationHistoryState, action) {
  return reducer(state, action);
}
